import React, { useState } from 'react';
import { IconButton } from '@ff-os/shared-react/components/buttons/icon-button/IconButton';
import { UploadError } from '@ff-os/shared-react/components/file-uploader/FileUploader';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowBody } from '@ff-os/shared-react/components/window/partials/WindowBody';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { Window } from '@ff-os/shared-react/components/window/Window';
import { PhotoPrintsOrderButton } from '../PhotoPrintsOrderButton';
import { PhotoPrintsWindowErrors } from '../PhotoPrintsWindowErrors';
import { PhotoPrintGroupsGrid } from './PhotoPrintGroupsGrid';
import { PhotoPrintsDropzone } from './PhotoPrintsDropzone';
import styles from './PhotoPrintsWindowDesktop.module.scss';

export const PhotoPrintsWindowDesktop = ({ close }: Props) => {
    const [uploadErrors, setUploadErrors] = useState<UploadError[]>([]);
    return (
        <Window fullHeight fullWidth close={close}>
            <WindowHeader>
                <div className={styles.header}>
                    <IconButton small
                        onClick={close}>
                        <Icon type='general-ui-close' strokeWidth={2} size='small' />
                    </IconButton>
                    <PhotoPrintsOrderButton className={styles.orderButton} />
                </div>
            </WindowHeader>
            <WindowBody>
                <PhotoPrintsDropzone setUploadErrors={(errors) => setUploadErrors(errors)}>
                    <PhotoPrintGroupsGrid
                        setUploadErrors={setUploadErrors}
                        initialUploadErrors={uploadErrors} />
                </PhotoPrintsDropzone>
            </WindowBody>
            <PhotoPrintsWindowErrors />
        </Window>
    );
};

type Props = {
    close: () => void;
};